import Seo from './Seo'
import config from 'src/config'
import ModernCart from './Modern/ModernCart'

/* Next */
import Link from 'src/components/Link'

/* Redux */
import Redux from './Redux'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import useStyles from './styles'
import { pageBuilderPurchaseButtonSx } from 'src/theme/pageBuilderButtons'

/* Components */
import Lehr from './Lehr'
import Inhalt from './Components/Inhalt/Inhalt'
import Zusammenfassung from './Components/Zusammenfassung/Zusammenfassung'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Types */
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Warenkorb' },
]

const ClassicCart = () => {
  const classes = useStyles()

  const { items } = Redux()
  const hasInquireOnlyItems = Object.values(items).some(
    item => item.inquireOnly || item.purchaseMode === 'inquiry',
  )

  if (Object.keys(items).length === 0) return <Lehr />
  
  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      Dein Warenkorb
    </Typo>

    <div className={classes.warenkorb}>

      <Inhalt />

      <div className={classes.zusammenfassung}>
        <Zusammenfassung displayVersandkostenHinweis />
        {hasInquireOnlyItems && (
          <Alert severity='info' sx={{ mb: 2 }}>
            Für Artikel auf Anfrage ist keine direkte Online-Bestellung möglich. Bitte entferne diese Artikel aus dem Warenkorb und nutze die Anfragefunktion am Produkt.
          </Alert>
        )}
        {hasInquireOnlyItems
          ? <Button
              color='primary' size='large' variant='contained' fullWidth
              className={classes.kasseButton}
              sx={pageBuilderPurchaseButtonSx}
              disabled
            >
              Zur Kasse
            </Button>
          : <Link href='/kasse' passHref legacyBehavior>
              <Button
                color='primary' size='large' variant='contained' fullWidth
                className={classes.kasseButton}
                sx={pageBuilderPurchaseButtonSx}
              >
                Zur Kasse
              </Button>
            </Link>
        }
      </div>

    </div>

  </Container>
}

const Warenkorb = () => config.cartVariant === 'modern' ? <ModernCart /> : <ClassicCart />

export default Warenkorb
